import { Component, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BookingSlot } from '../../models/booking-slot';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-time-slot-event-list',
  templateUrl: './time-slot-event-list.component.html',
  styleUrls: ['./time-slot-event-list.component.css']
})
export class TimeSlotEventListComponent implements OnInit, OnDestroy {

  @Output()
  timeSlotSelected: EventEmitter<BookingSlot> = new EventEmitter<BookingSlot>();

  private _shiftDaySubscription: Subscription;

  constructor(
    private bookingOrderService: BookingOrderService,
    public bookingSlotStateService: BookingSlotStateService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this._unsubscribeShiftDaySubscription();
  }

  get selectedDate(): Date {
    return this.bookingSlotStateService.selectedDate;
  }

  get bookingSlots(): Array<BookingSlot> {
    return this.bookingSlotStateService.bookingSlots;
  }

  get displayTimeSlots(): BookingSlot[] {
    return this.bookingSlotStateService.displayTimeSlots.filter(x => x.capacity >= this.personCount);
  }

  get isLoading(): boolean {
    return this.loadingSpinnerService.hasSpinner;
  }

  get minPersonCount(): number {
    return this.bookingOrderService.eventCache.minPersonCount;
  }

  get maxPersonCount(): number {
    return this.bookingOrderService.eventCache.maxPersonCount;
  }

  get selectedAreaItemName(): string {
    const selectedAreaItem = this.bookingOrderService.selectedAreaItem;
    const selectedAreaItemName = selectedAreaItem && selectedAreaItem.name ? selectedAreaItem.name : '';
    return selectedAreaItemName;
  }

  get personCount(): number {
    if (!this.bookingOrderService.eventCache) {
      return 0;
    }

    return this.bookingOrderService.eventCache.personCount;
  }

  set personCount(value: number) {
    this.bookingOrderService.eventCache.personCount = value;
  }

  onClickTimeSlot(timeSlot: BookingSlot) {
    if (this.canSelectSlot(timeSlot)) {
      this.timeSlotSelected.emit(timeSlot);
    }
  }

  canSelectSlot(bookingSlot: BookingSlot): boolean {
    return this.bookingSlotStateService.canSelectSlot(bookingSlot);
  }

  get showNoSlotMessage(): boolean {
    return !this.isLoading && this.bookingSlotStateService.displayTimeSlots.filter(x => x.capacity >= this.personCount).length === 0;
  }

  nextDayClick() {
    this._unsubscribeShiftDaySubscription();
    this._shiftDaySubscription = this.bookingSlotStateService.shiftDay(1).subscribe();
  }

  prevDayClick() {
    this._unsubscribeShiftDaySubscription();
    this._shiftDaySubscription = this.bookingSlotStateService.shiftDay(-1).subscribe();
  }

  private _unsubscribeShiftDaySubscription(): void {
    if (this._shiftDaySubscription) {
      this._shiftDaySubscription.unsubscribe();
      this._shiftDaySubscription = null;
    }
  }
}
